import React from 'react'
import styled from 'styled-components'
import { margin, marginSizes } from '@jarvis.oddle/core/theme/default'
import { InformationalDialog } from '@jarvis.oddle/core/components/Dialog'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import PoweredByOddlePass, {
  UTMSource
} from 'src/components/molecules/PoweredByOddlePass'
import loginFlow from 'src/flows/loginFlow'
import { makeControlledModal } from 'src/decorators/ModalController'

const StyledPoweredByOddlePass = styled(PoweredByOddlePass)`
  && {
    margin-top: ${margin[marginSizes.extraLarge]};
    margin-bottom: ${margin[marginSizes.none]};
  }
`

const PasswordResetModal = React.memo(
  ({
    modal,
    email
  }: {
    modal: {
      show: boolean
      onClose: (handler?) => void
      onClosed: () => void
    }
    email: string
  }): JSX.Element => {
    const { t } = React.useContext(TranslationContext)

    const goToLogInModal = React.useCallback(() => {
      loginFlow.send('login', { email })
    }, [email])

    return (
      <InformationalDialog
        {...modal}
        onConfirm={goToLogInModal}
        header={t('Please check your email inbox.')}
        body={t(
          'Please follow the instructions sent to _email_ to reset your password.',
          { email }
        )}
        footer={
          <StyledPoweredByOddlePass
            UTMSource={UTMSource.SIGNIN_MODAL}
            copyText={t(
              'Once successfully reset, your Oddle Pass (_email_) can be used to log in to all restaurant partners on Oddle',
              { email }
            )}
          />
        }
        confirmText={t('Log in')}
      />
    )
  }
)

export default makeControlledModal(PasswordResetModal, 'PasswordResetModal')
